import React from 'react';
import SidebarLayout from './SidebarLayout';

const DashboardMasajista = () => {
    const menuItems = [
        { path: '/masajista/turnos', icon: '📅', label: 'Mis Turnos', description: 'Ver y gestionar turnos' },
        { path: '/masajista/agenda', icon: '🗓️', label: 'Mi Agenda', description: 'Vista semanal de turnos' },
       // { path: '/perfil', icon: '👤', label: 'Mi Perfil', description: 'Datos personales' },
    ];

    return (
        <SidebarLayout menuItems={menuItems} subtitle="Panel Masajista" />
    );
};

export default DashboardMasajista;